/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Category_Illustration_3dInputs */

const en_gallery_category_illustration_3d = /** @type {(inputs: Gallery_Category_Illustration_3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustration & 3D`)
};

const es_gallery_category_illustration_3d = /** @type {(inputs: Gallery_Category_Illustration_3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilustracion y 3D`)
};

/**
* | output |
* | --- |
* | "Illustration & 3D" |
*
* @param {Gallery_Category_Illustration_3dInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const gallery_category_illustration_3d = /** @type {((inputs?: Gallery_Category_Illustration_3dInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Category_Illustration_3dInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_category_illustration_3d(inputs)
	return es_gallery_category_illustration_3d(inputs)
});